import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import useCommon from '@utils/hooks/common';
import PopupContainer from '@components/layout/PopupContainer';
import GradientButton from '@components/GradientButton';
import styles from './styles';

interface TournamentWaitingForPlayersModalSheetProps {
  isModalSheetOpen: boolean;
  onModalSheetClose: () => void;
  tournamentName: string;
  currentPlayers: number;
  minPlayersRequired: number;
}

const TournamentWaitingForPlayersModalSheet: React.FC<TournamentWaitingForPlayersModalSheetProps> = ({
  isModalSheetOpen,
  onModalSheetClose,
  tournamentName,
  currentPlayers,
  minPlayersRequired,
}) => {
  const {t, system, classes} = useCommon({
    withTranslation: ['tournament'],
    withStyles: {styles, hasProps: true},
    observers: ['system'],
  });

  useEffect(() => {
    const handleModalClose = () => {
      onModalSheetClose();
    };
    system.on('tournamentWaitingForPlayersOnClose', handleModalClose);
    return () => {
      system.off('tournamentWaitingForPlayersOnClose', handleModalClose);
    };
  }, [onModalSheetClose, system]);

  const handleConfirm = () => {
    onModalSheetClose();
  };

  const playersNeeded = minPlayersRequired - currentPlayers;

  return (
    <PopupContainer
      visible={isModalSheetOpen}
      onCancel={onModalSheetClose}
      title={t('tournament:waiting_for_players.title')}
      mobileModalProps={{snapPoints: [570, 0]}}
    >
      <div className={classes.container}>
        <div className={classes.topSection}>
          <img height={200} src="/images/tournament/thanks_joining.svg" />
          <div style={{textAlign: 'center', lineHeight: '1.5', fontSize: '18px', fontWeight: 'bold'}}>
            {t('tournament:waiting_for_players.message', {count: playersNeeded})}
          </div>
        </div>
        <div className={classes.bottomSection}>
          <GradientButton
            isBlue={true}
            style={{height: 50}}
            className={classes.closeButton}
            onClick={handleConfirm}
          >
            {t('common:confirm')}
          </GradientButton>
        </div>
      </div>
    </PopupContainer>
  );
};

export default TournamentWaitingForPlayersModalSheet;